// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"10":"4c3400c9","135":"256173b8","253":"89ac59d6","389":"ed366672","429":"4ab3214b","441":"982c068c","505":"a936052e","593":"15c9b28a","713":"61118ae4","732":"82690f50","817":"269a1eac","864":"436d30f2","871":"f14d4f99"}[chunkId] + ".js";
};